import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { api, auth } from '../api/client'

export default function LoginPage() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [err, setErr] = useState<string | null>(null)
    const [busy, setBusy] = useState(false)
    const nav = useNavigate()
    const loc = useLocation() as any

    async function doLogin(e: React.FormEvent) {
        e.preventDefault()
        setBusy(true); setErr(null)
        try {
            const resp: any = await api('/api/auth/login', {
                method: 'POST',
                body: JSON.stringify({ email, password })
            })
            auth.save(resp.token, { name: resp.name, email: resp.email, role: resp.role })
            const dest = loc.state?.from?.pathname || '/dashboard'
            nav(dest)
        } catch (e: any) {
            setErr(e.message || 'login failed')
        } finally {
            setBusy(false)
        }
    }

    return (
        <div style={{ maxWidth: 360, margin: '60px auto' }}>
            <h1>Sign In</h1>
            <form onSubmit={doLogin} className="card">
                <div className="form-row">
                    <label>Email</label>
                    <input type="email" required value={email} onChange={e => setEmail(e.target.value)} autoFocus />
                </div>
                <div className="form-row">
                    <label>Password</label>
                    <input type="password" required value={password} onChange={e => setPassword(e.target.value)} />
                </div>
                {err && <div className="error">{err}</div>}
                <button type="submit" disabled={busy} style={{ width: '100%', marginTop: 8 }}>
                    {busy ? 'Signing in...' : 'Sign In'}
                </button>
            </form>
        </div>
    )
}
